export default {
  props: {
    impressions: Array,
  },
};
